<template>
    <div>
        <Loader v-if="isLoading"></Loader>
        <div class="container">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Contratação Garantia Locatícia</h4>
                                </div>
                            </div>
                            <div class="card-body">
                                <v-tabs v-model="tab" color="deep-purple-accent-4" bg-color="#f7f7f7">
                                    <v-tab value="dados" class="tabinfo">Nova Contratação</v-tab>
                                </v-tabs>
                                <v-window v-model="tab">
                                    <v-window-item value="dados">
                                        <v-form>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12" md="6">
                                                        <v-card color="#f7f7f7" style="padding: 15px;">
                                                            <v-row style="padding-bottom:20px;">
                                                                <v-col cols="12">
                                                                    <v-row v-if="User.garid == 0">
                                                                        <v-col cols="12" md="12">
                                                                            <label>Garantidora</label>
                                                                            <select v-model="selectedGarantidora"
                                                                                class="form-select form-control"
                                                                                @change="BuscaImobialiarias()">
                                                                                <option :value=null>Selecione</option>
                                                                                <option
                                                                                    v-for="optionTipo in DadosGarantidora"
                                                                                    :key="optionTipo.garId"
                                                                                    :value="optionTipo">{{
                                                                                        optionTipo.garNomeEmpresa }}
                                                                                </option>
                                                                            </select>
                                                                        </v-col>
                                                                    </v-row>
                                                                    <v-row v-if="User.tpeid != 3">
                                                                        <v-col cols="12" md="12"
                                                                            v-if="selectedGarantidora != '' && selectedGarantidora != null && ListImobiliarias != ''">
                                                                            <label>Imobiliária</label>
                                                                            <select v-model="selectedImobiliaria"
                                                                                class="form-select form-control"
                                                                                @change="SelecionarConsumidor()">
                                                                                <option :value=null>Selecione</option>
                                                                                <option
                                                                                    v-for="optionTipo in ListImobiliarias"
                                                                                    :key="optionTipo.imoId"
                                                                                    :value="optionTipo">{{
                                                                                        optionTipo.nomeConcatenado }}
                                                                                </option>
                                                                            </select>
                                                                        </v-col>
                                                                    </v-row>
                                                                    <v-row>
                                                                        <v-col cols="12" md="12"
                                                                            v-if="selectedImobiliaria != '' && selectedImobiliaria != null && ListConsumidor != ''">
                                                                            <label>Cliente</label>
                                                                            <select v-model="selectedConsumidor"
                                                                                @change="ValidaConsumidor()"
                                                                                class="form-select form-control">
                                                                                <option :value=null>Selecione</option>
                                                                                <option
                                                                                    v-for="optionTipo in ListConsumidor"
                                                                                    :key="optionTipo.cliId"
                                                                                    :value="optionTipo">{{
                                                                                        optionTipo.nomeConcatenado }}
                                                                                </option>
                                                                            </select>
                                                                        </v-col>
                                                                    </v-row>
                                                                    <v-row>
                                                                        <v-col cols="12" md="12"
                                                                            v-if="selectedConsumidor == '' || selectedConsumidor == null && selectedImobiliaria != '' && selectedImobiliaria != null">
                                                                            <router-link type="button"
                                                                                class="btn btn-info" to="/clientes">
                                                                                Novo Cliente
                                                                            </router-link>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card>
                                                        <v-card color="#f7f7f7" style="padding: 15px;margin-top: 20px;"
                                                            v-if="endereco != '' && tipoImovel != ''">
                                                            <v-item-group v-model="ProdutoSelected">
                                                                <v-container>
                                                                    <v-row>
                                                                        <h5 class="subtitulo"
                                                                            style="padding-bottom: 15px;padding-left:10px;">
                                                                            Selecione o produto</h5>
                                                                    </v-row>
                                                                    <v-row>
                                                                        <v-col v-for="mens in ListProdutos"
                                                                            :key="mens.proId" cols="12" md="6">
                                                                            <v-item>
                                                                                <v-card class="d-flex align-center" dark
                                                                                    height="230" @click="toggle(mens)"
                                                                                    :class="{ 'border-green': ProdutoSelected === mens }">
                                                                                    <div class="flex-grow-1 text-center"
                                                                                        style="justify-content: center;">
                                                                                        <img :src="buildFileUrl(mens.proProdutos.proCampoExtra10)"
                                                                                            style="height: 150px;"
                                                                                            class="mx-auto" />
                                                                                        {{ mens.nomeConcatenado }}
                                                                                    </div>
                                                                                    <v-icon
                                                                                        v-if="ProdutoSelected === mens"
                                                                                        class="check-icon">mdi-check</v-icon>
                                                                                </v-card>
                                                                            </v-item>
                                                                        </v-col>
                                                                    </v-row>
                                                                </v-container>
                                                            </v-item-group>
                                                        </v-card>
                                                    </v-col>
                                                    <v-col cols="12" md="6" v-if="liberaEndGarantia">
                                                        <v-card color="#f7f7f7" style="padding: 15px;">
                                                            <v-row style="line-height: 0;">
                                                                <v-col cols="12"
                                                                    v-if="endereco == '' || endereco == null">
                                                                    <br><button class="btn btn-info"
                                                                        @click.prevent="dialogEndereco = true">Adicionar
                                                                        Endereço da Contratação</button>
                                                                </v-col>
                                                                <v-col cols="12" v-else>
                                                                    <br><button class="btn btn-info"
                                                                        @click.prevent="dialogEndereco = true">Editar
                                                                        Endereço da Contratação</button>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row v-if="endereco != '' && endereco != null">
                                                                <v-col cols="12" style="line-height: 0;">
                                                                    <small><strong>Endereço:</strong> {{ endereco }} -
                                                                        {{ numeroend }} - {{ complemento }}</small>
                                                                </v-col>
                                                                <v-col cols="12" style="line-height: 0;">
                                                                    <small><strong>CEP: </strong>{{ numCep }}</small>
                                                                </v-col>
                                                                <v-col cols="12" style="line-height: 0;">
                                                                    <small><strong>Cidade:</strong> {{ nomeCidade }} /
                                                                        {{ siglaEstado }} - {{ nomeBairro }}</small>
                                                                </v-col>
                                                                <v-col cols="12" style="line-height: 0;" v-if="residencialTipo!=''">
                                                                    <small><strong>Tipo Imóvel:</strong> {{ tipoImovel
                                                                        }} {{ residencialTipo }}</small>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card>
                                                        <v-card color="#f7f7f7" style="padding: 15px;margin-top: 20px;"
                                                            v-if="ListaPedidoItem != ''">
                                                            <v-row style="padding: 10px;">
                                                                <div style="padding-top: 20px;min-height: 350px;">
                                                                    <h5 class="subtitulo"
                                                                        style="padding-bottom: 15px;padding-left:10px;">
                                                                        Itens da contratação</h5>
                                                                    <div v-for="(produto, index) in ListaPedidoItem"
                                                                        :key="produto.pdiId"
                                                                        class="descricao-pedido border-top py-3">
                                                                        <div class="row">
                                                                            <div
                                                                                class="col-6 col-md-3 d-flex align-items-center">
                                                                                <div class="descricao-content">
                                                                                    <h6 class="subtitulo">{{
                                                                                        produto.nomeConcatenado }}</h6>
                                                                                    <p class="texto-mensagem"> Código:
                                                                                        {{ produto.proProdutos.proId }}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                class="col-6 col-md-5 d-flex align-items-center">
                                                                                <small>Vigência de {{
                                                                                    formattedDate(produto.vigenciaini)
                                                                                    }} até {{
                                                                                        formattedDate(produto.vigenciafim)
                                                                                    }} </small>
                                                                            </div>
                                                                            <div
                                                                                class="col-6 col-md-3 d-flex align-items-center">
                                                                                <div class="descricao-content">
                                                                                    <h6 class="subtitulo"
                                                                                        style="font-size: 15px;">
                                                                                        R$ {{
                                                                                            parseFloat(produto.valorTotalProduto).toFixed(2).toString().replace('.',
                                                                                                ',')
                                                                                        }}</h6>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                class="col-6 col-md-1 d-flex align-items-center">
                                                                                <a href="#" data-toggle="tooltip"
                                                                                    data-placement="top" title="Excluir"
                                                                                    @click.prevent="ExcluiProduto(index)">
                                                                                    <i class="fa fa-window-close"
                                                                                        style="color: black;font-size: 13px;"></i>
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </v-row>
                                                        </v-card>
                                                        <v-card color="#f7f7f7" style="padding: 15px;margin-top: 20px;"
                                                            v-if="ListaPedidoItem != ''">
                                                            <v-row>
                                                                <v-col cols="12" md="12">
                                                                    <div
                                                                        class="d-flex align-items-center justify-content-between">
                                                                        <h5 class="subtitulo">Total</h5>
                                                                        <h6 class="subtitulo">R$ {{
                                                                            parseFloat(TotalPedido).toFixed(2).toString().replace('.',
                                                                                ',')
                                                                        }}</h6>
                                                                    </div>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card>
                                                        <v-card color="#f7f7f7" style="padding: 15px;margin-top: 20px;"
                                                            v-if="ListaFormasPagamento != ''">
                                                            <v-row>
                                                                <v-col cols="12" md="12" v-if="ListaFormasPagamento!=''">
                                                                    <div>
                                                                        <label>Selecione a forma de pagamento</label>
                                                                        <select v-model="selectedFormaPagamento"
                                                                                class="form-select form-control">
                                                                                <option :value=null>Selecione</option>
                                                                                <option
                                                                                    v-for="optionTipo in ListaFormasPagamento"
                                                                                    :key="optionTipo.cfpId"
                                                                                    :value="optionTipo">{{
                                                                                        optionTipo.cfpNome }}
                                                                                </option>
                                                                            </select>
                                                                    </div>
                                                                </v-col>
                                                                  <v-col cols="12" md="12" v-if="selectedFormaPagamento?.cfpId === 3">
                                                                    <div>
                                                                        <label>Selecione parcelamento cobrança</label>
                                                                        <select v-model="selectedSetup"
                                                                                class="form-select form-control">
                                                                                <option :value=null>Selecione</option>
                                                                                <option :value=1>Entrada + 11x com Setup 1º Parcela</option>
                                                                                <option :value=0>Entrada + 11x com Setup parcelado</option>
                                                                                <option :value=2>1x com Setup</option>
                                                                                <option :value=3>2x com Setup parcelado</option>
                                                                                <option :value=4>3x com Setup parcelado</option>
                                                                                <option :value=5>4x com Setup parcelado</option>
                                                                                <option :value=6>5x com Setup parcelado</option>
                                                                                <option :value=7>6x com Setup parcelado</option>
                                                                                <option :value=8>7x com Setup parcelado</option>
                                                                                <option :value=9>8x com Setup parcelado</option>
                                                                                <option :value=10>9x com Setup parcelado</option>
                                                                                <option :value=11>10x com Setup parcelado</option>
                                                                                <option :value=12>11x com Setup parcelado</option>
                                                                                <option :value=13>12x com Setup parcelado</option>
                                                                                <option :value=14>Setup Entrada + 12x parcelas</option>
                                                                            </select>
                                                                    </div>
                                                                </v-col>
                                                                 <v-col cols="12" md="12" v-else-if="selectedFormaPagamento?.cfpId === 4">
                                                                    <div>
                                                                        <label>Selecione parcelamento cobrança</label>
                                                                            <select v-model="selectedSetup"
                                                                                class="form-select form-control">
                                                                                <option :value=null>Selecione</option>
                                                                                <option :value=2>1x valor total</option>
                                                                            </select>
                                                                    </div>
                                                                </v-col>
                                                                  <v-col cols="12" md="12" v-else-if="selectedFormaPagamento?.cfpId === 6">
                                                                    <div>
                                                                        <label>Selecione parcelamento cobrança</label>
                                                                        <select v-model="selectedSetup"
                                                                                class="form-select form-control">
                                                                                <option :value=null>Selecione</option>
                                                                                <option :value=1>Entrada + 11x com Setup 1º Parcela</option>
                                                                                <option :value=0>Entrada + 11x com Setup parcelado</option>
                                                                                <option :value=14>Setup Entrada + 12x parcelas</option>
                                                                            </select>
                                                                    </div>
                                                                </v-col>
                                                                 <v-col cols="12" md="12" v-else-if="selectedFormaPagamento?.cfpId === 7">
                                                                    <div>
                                                                        <label>Selecione parcelamento cobrança</label>
                                                                        <select v-model="selectedSetup"
                                                                                class="form-select form-control">
                                                                                <option :value=null>Selecione</option>
                                                                                <option :value=2>1 parcela</option>
                                                                                <option :value=3>2 parcelas</option>
                                                                                <option :value=4>3 parcelas</option>
                                                                                <option :value=5>4 parcelas</option>
                                                                                <option :value=6>5 parcelas</option>
                                                                                <option :value=7>6 parcelas</option>
                                                                                <option :value=8>7 parcelas</option>
                                                                                <option :value=9>8 parcelas</option>
                                                                                <option :value=10>9 parcelas</option>
                                                                                <option :value=11>10 parcelas</option>
                                                                                <option :value=12>11 parcelas</option>
                                                                                <option :value=13>12 parcelas</option>
                                                                            </select>
                                                                    </div>
                                                                </v-col>
                                                            </v-row>
                                                        </v-card>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="4" style="text-align: right;">
                                                        <button type="button" @click="LimparMemoria(1)"
                                                            class="btn btn-link">
                                                            Limpar
                                                        </button>
                                                    </v-col>
                                                      <v-col cols="12" md="4" style="text-align: left;"
                                                        v-if="ListaPedidoItem != ''">
                                                        <button type="button" style="color:#ffffff;"
                                                            class="btn btn-warning" @click="AvisoSemAnalise()">
                                                            Enviar Contratação sem Análise
                                                        </button>
                                                    </v-col>
                                                    <v-col cols="12" md="4" style="text-align: left;"
                                                        v-if="ListaPedidoItem != ''">
                                                        <button type="button" style="color:#ffffff;"
                                                            class="btn btn-success" @click="GerarPedido(1)">
                                                            Enviar Contratação para Análise
                                                        </button>
                                                    </v-col> 
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                </v-window>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--modal endereco-->
        <v-row justify="center">
            <v-dialog v-model="dialogEndereco" persistent class="controlcelEnd" transition="dialog-bottom-transition">
                <v-card>
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Cadastrar Endereço do imóvel</span>
                        <button
                            @click="LimparEndereco()"
                            style="background: none;
                                border: none;
                                font-size: 30px;
                                line-height: 1;
                                cursor: pointer;
                                float: right;"
                            aria-label="Fechar"
                        >
                            ×
                        </button>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="5">
                                        <label>CEP</label>
                                        <input v-model="numCep" v-mask="'#####-###'" type="text" class="form-control"
                                            placeholder="CEP" />
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <a href="#" class="btn btn-secondary"
                                            style="padding: 5px;margin: 5px;font-size: 14px;margin-top: 25px;"
                                            @click.prevent="Buscacep(numCep)">Verificar</a>
                                    </v-col>
                                    <v-col cols="12" md="5" v-show="showend">
                                        <label>Endereço</label>
                                        <input v-model="endereco" type="text" class="form-control"
                                            placeholder="Endereço" />
                                    </v-col>
                                    <v-col cols="12" md="2" v-show="showend">
                                        <label>Número</label>
                                        <input v-model="numeroend" type="number" class="form-control"
                                            placeholder="Número" />
                                    </v-col>
                                    <v-col cols="12" md="2" v-show="showend">
                                        <label>Complemento</label>
                                        <input v-model="complemento" type="text" class="form-control"
                                            placeholder="Complemento" />
                                    </v-col>
                                    <v-col cols="12" md="3" v-show="showend">
                                        <label>Cidade</label>
                                        <input v-model="nomeCidade" type="text" class="form-control"
                                            placeholder="Cidade" />
                                    </v-col>
                                    <v-col cols="12" md="2" v-show="showend">
                                        <label>Estado</label>
                                        <input v-model="siglaEstado" type="text" v-mask="'AA'" class="form-control"
                                            placeholder="UF" />
                                    </v-col>
                                    <v-col cols="12" md="3" v-show="showend">
                                        <label>Bairro</label>
                                        <input v-model="nomeBairro" type="text" class="form-control"
                                            placeholder="Bairro" />
                                    </v-col>
                                    <v-col cols="12" md="3" v-show="showend">
                                    <strong>Imóvel</strong>

                                    <v-radio-group
                                        v-model="tipoImovel"
                                        style="display:flex; flex-direction:row; flex-wrap:wrap;"
                                    >
                                        <v-radio
                                        v-for="t in tiposImoveis"
                                        :key="t.id"
                                        :label="t.id"
                                        :value="t.id"
                                        style="width: 280px;"
                                        />
                                    </v-radio-group>
                                    </v-col>

                                    <v-col cols="12" md="3" v-show="showend && tipoImovel">
                                    <strong>Tipo do Imóvel</strong>

                                    <v-select
                                        v-model="residencialTipo"
                                        :items="subtiposDisponiveis"
                                        item-title="nome"
                                        item-value="id"
                                        :disabled="!subtiposDisponiveis.length"
                                        clearable
                                        dense
                                        variant="outlined"
                                    />
                                    </v-col>

                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions v-show="showend">
                        <v-spacer></v-spacer>
                        <v-btn class="btn btn-success" style="padding: 5px;margin: 5px;font-size: 13px;color:#ffffff;"
                            @click.prevent="ValidaEndereco()">Confirmar Endereço</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

        <!--modal produto garantia-->
        <v-row justify="center">
            <v-dialog v-model="dialogProdutoGarantia" persistent class="controlcelEnd"
                transition="dialog-bottom-transition">
                <v-card>
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Produto Garantia {{ tipoImovel
                            }}</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="6">
                                        <v-row v-for="(grids, index) in ProdutosGrid" :key="index"
                                            style="line-height:0 !important">
                                            <v-col cols="12" md="6" class="d-flex align-center">
                                                {{ grids.pisNome }}
                                            </v-col>
                                            <v-col cols="12" md="4">
                                                <v-text-field class="input" v-model="grids.pisCampoExtra1" v-decimal
                                                    variant="outlined" placeholder="Valor R$ "></v-text-field>
                                            </v-col>
                                        </v-row>
                                         <v-alert style="padding-top: 20;"
                                            density="compact"
                                            text="Valores zerados não entram em caso de sinistro."
                                            title="Aviso"
                                            type="warning"
                                        ></v-alert>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-row>
                                            <v-col cols="12" md="12" v-if="!selectedImobiliaria.planoCoberturaLivre">
                                                <small>Selecione a cobertura:</small>
                                                <select v-model="CoberturaSelected" class="form-select form-control" @change="AtualizaTaxasPlanos()">
                                                    <option :value=null>Selecione</option>
                                                    <option v-for="(optionTipo, index) in ListaPlanosCobertura.filter(x=> x.ipcTipoCobertura == tipoImovel)"
                                                        :key="index" :value="optionTipo">{{ optionTipo.ipcCobertura }}x
                                                    </option>
                                                </select>
                                            </v-col>
                                            <v-col cols="12" md="12" v-if="selectedImobiliaria.planoCoberturaLivre">
                                                <small>Forma de cálculo da taxa:</small>
                                                <select v-model="TipoCalculoTaxa" class="form-select form-control"
                                                    @change="AtualizaTipoCalculoTaxa()">
                                                    <option value="taxa">Informar taxa</option>
                                                    <option value="valor">Informar valor do pacote</option>
                                                </select>
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-if="selectedImobiliaria.planoCoberturaLivre && TipoCalculoTaxa == 'taxa'">
                                                <small>Digite o % da taxa a ser aplicada:</small>
                                                <select v-model="ProdutosTaxas" class="form-select form-control"
                                                    @change="ValorPacoteInformado = null">
                                                    <option :value=null>Selecione</option>
                                                    <option v-for="(optionTipo, index) in ListaProdutosTaxasFilter"
                                                        :key="index" :value="optionTipo.value">{{ optionTipo.Nome }}
                                                    </option>
                                                </select>
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-if="selectedImobiliaria.planoCoberturaLivre && TipoCalculoTaxa == 'valor'">
                                                <small>Digite o valor do pacote R$:</small>
                                                <v-text-field class="input" v-model="ValorPacoteInformado" v-decimal
                                                    variant="outlined" placeholder="Valor R$ "
                                                    @input="AtualizaTaxaPorValorPacote()"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <small>Digite o valor do Setup da Imobiliária R$:</small>
                                                <v-text-field class="input" v-model="PlanosGarantiasSelected" v-decimal
                                                    variant="outlined" placeholder="Valor R$ "></v-text-field>
                                            </v-col>
                                             <v-col cols="12" md="12" v-if="selectedImobiliaria.planoCoberturaLivre">
                                                <small>Digite qtde vezes da cobertura:</small>
                                                <select v-model="Qtdemultiplicador" class="form-select form-control">
                                                    <option :value=null>Selecione</option>
                                                    <option v-for="(optionTipo, index) in ListQtdemultiplicador"
                                                        :key="index" :value="optionTipo.value">{{ optionTipo.nome }}
                                                    </option>
                                                </select>
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <small>Resultado</small>
                                                <v-card color="#f7f7f7" style="padding: 15px;margin-top: 20px;"
                                                    v-if="ExibeResultadoGarantia">
                                                    Pacote: R$ {{ formatarValor(ValorPacoteGarantiaComputed)
                                                    }}<br>
                                                    Taxa: {{ formatarPercentualTaxa(TaxaGarantiaComputed)
                                                    }}<br>
                                                    Taxa Setup: R$ {{ formatarValor(parseValorDecimal(PlanosGarantiasSelected))
                                                    }}<br>
                                                    <strong>Valor Total: R$ {{
                                                        formatarValor(parseFloat(ValorPacoteGarantiaComputed) +
                                                            parseValorDecimal(PlanosGarantiasSelected)) }} </strong>
                                                </v-card>
                                                <small>* Todos os valores informados são de responsabilidade da
                                                    imobiliária parceira.</small>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions v-show="showend">
                        <v-spacer></v-spacer>
                        <v-btn style="padding: 5px;margin: 5px;font-size: 12px;color:#000000"
                            @click.prevent="dialogProdutoGarantia = !dialogProdutoGarantia">Cancelar</v-btn>
                        <v-btn class="btn btn-success" style="padding: 5px;margin: 5px;font-size: 12px;color:#ffffff"
                            @click.prevent="AdicionarGarantia()">Adicionar Garantia</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'
import Loader from '../../components/PageLoader.vue'


export default {
    name: 'NovaContratacaoGarantiaView',
    components: {
        EasyDataTable,
        moment,
        Loader
    },
    data: () => ({
        tab: null,
        NomeTela: 'Contratação',
        InfoTela: 'Nova Contratação',
        CadastroTelas: [{ cdtId: 28, cdtNome: "Contratação" }],
          User: {
            garid:0,
            tpeid:0,
            pesid:0,
            cusid:0
        },
        //cli geral
        ListaFormasPagamento:[],
        DadosPagamento:[],
        TipoOperadoras:[],
        selectedFormaPagamento:null,
        ListClientesGeral: [],
        //garantidoras
        selectedGarantidora: null,
        //Imobiliarias
        ListImobiliariaGeral: [],
        selectedImobiliaria: null,
        ListImobiliarias: [],
        //Imobliarias
        //consumidor
        selectedConsumidor: null,
        ListConsumidor: [],
        Cliente: {},
        liberaEndGarantia: false,
        EnderecoContrato: [],
        //consumidor
        //endereco
        dialogEndereco: false,
        endereco: '',
        numeroend: '',
        complemento: '',
        siglaEstado: '',
        nomeCidade: '',
        nomeBairro: '',
        numCep: '',
        Observacoes: '',
        Retornocep: {},
        showend: false,
        //endereco
        //pedido
        Pedidos: [],
        PedidosCli: [],
        TotalPedido: 0,
        ValorDesconto: 0,
        ValorFrete: 0,
        ListaPedidoItem: [],
        ListaPedidoItemAdicional: [],
        Situacoes: [],
        //pedido
        //produtos
        ProdutoSelected: '',
        ListProdutosGeral: [],
        ListProdutos: [],
        selectedItemProduto: null,
        dialogProdutoGarantia: false,
        dialogProdutoSeguro: false,
        ProdutosGrid: [],
        PlanosGarantiasSelected: 0,
        PlanosGarantias: [],
        ProdutosTaxas: null,
        TipoCalculoTaxa: 'taxa',
        ValorPacoteInformado: null,
     ListaProdutosTaxas: [
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 3%', value: 0.03 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 4%', value: 0.04 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 5%', value: 0.05 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 6%', value: 0.06 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 7%', value: 0.07 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 8%', value: 0.08 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 9%', value: 0.09 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 9,5%', value: 0.095 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 10%', value: 0.10 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 10,5%', value: 0.105 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 11%', value: 0.11 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 11,5%', value: 0.115 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 12%', value: 0.12 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 12,5%', value: 0.125 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 13%', value: 0.13 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 13,5%', value: 0.135 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 14%', value: 0.14 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 14,5%', value: 0.145 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 15%', value: 0.15 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 15,5%', value: 0.155 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 16%', value: 0.16 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 16,5%', value: 0.165 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 17%', value: 0.17 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 17,5%', value: 0.175 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 18%', value: 0.18 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 18,5%', value: 0.185 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 19%', value: 0.19 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 19,5%', value: 0.195 },
                { tipo: 'Residencial', Nome: 'Garantia Locatícia Residencial 20%', value: 0.20 },

                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 3%', value: 0.03 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 4%', value: 0.04 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 5%', value: 0.05 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 6%', value: 0.06 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 7%', value: 0.07 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 8%', value: 0.08 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 9%', value: 0.09 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 9,5%', value: 0.095 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 10%', value: 0.10 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 10,5%', value: 0.105 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 11%', value: 0.11 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 11,5%', value: 0.115 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 12%', value: 0.12 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 12,5%', value: 0.125 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 13%', value: 0.13 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 13,5%', value: 0.135 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 14%', value: 0.14 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 14,5%', value: 0.145 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 15%', value: 0.15 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 15,5%', value: 0.155 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 16%', value: 0.16 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 16,5%', value: 0.165 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 17%', value: 0.17 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 17,5%', value: 0.175 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 18%', value: 0.18 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 18,5%', value: 0.185 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 19%', value: 0.19 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 19,5%', value: 0.195 },
                { tipo: 'Comercial', Nome: 'Garantia Locatícia Comercial 20%', value: 0.20 }
            ],
                    ListaProdutosTaxasFilter: [],
        ValorTotal: 0,
        //produtos
        DadosCompra: {
            imobiliaria: [],
            consumidor: [],
            garantidora: [],
            produtos: [],
            mensagem: [],
            agenda: [],
            foto: [],
            avulsos: [],
            informacao: [],
            pagamento: [],
            cupom: [],
        },
        linkPagamento: null,
        //pagamentos
        DadosGarantidora: [],
        DadosConfiguracao: [],
        isLoading: false,
        RetornoSerasaAntigo: null,
        ListaContratos: [],
        ContratoPedido: [],
        Assinatura: [],
        selectedSetup: null,
        obsAnalise: '',
        Qtdemultiplicador:null,
        ListQtdemultiplicador:[
              { nome: '3x', value: '3x' },
              { nome: '4x', value: '4x' },
              { nome: '5x', value: '5x' },
              { nome: '6x', value: '6x' },
              { nome: '7x', value: '7x' },
              { nome: '8x', value: '8x' },
              { nome: '9x', value: '9x' },
              { nome: '10x', value: '10x' },
              { nome: '11x', value: '11x' },
              { nome: '12x', value: '12x' },
              { nome: '14x', value: '14x' },
              { nome: '16x', value: '16x' },
              { nome: '18x', value: '18x' },
              { nome: '20x', value: '20x' },
              { nome: '22x', value: '22x' },
              { nome: '24x', value: '24x' },
              { nome: '26x', value: '26x' },
              { nome: '28x', value: '28x' },
              { nome: '30x', value: '30x' },
              { nome: '120x', value: '120x' }
        ],
        ListaConsultasCredito: [],
        ListaPlanosCobertura: [],
        CoberturaSelected:null,
        //subitpos
        tipoImovel: null,     // "Residencial" | "Comercial"
        residencialTipo: null, 
        tiposImoveis:[
        {
            id: "Residencial",
            subtipos: [
            { id: "Casa", nome: "Casa" },
            { id: "Apartamento", nome: "Apartamento" },
            { id: "Sobrado", nome: "Sobrado" },
            { id: "Kitnet", nome: "Kitnet" },
            { id: "Studio", nome: "Studio" },
            { id: "Chácara", nome: "Chácara" },
            { id: "Sítio", nome: "Sítio" },
            { id: "Terreno residencial", nome: "Terreno residencial" }
            ]
        },
        {
            id: "Comercial",
            subtipos: [
            { id: "Sala", nome: "Sala" },
            { id: "Sobrado", nome: "Sobrado" },
            { id: "Salão", nome: "Salão" },
            { id: "Loja", nome: "Loja" },
            { id: "Galpão", nome: "Galpão" },
            { id: "Depósito", nome: "Depósito" },
            { id: "Prédio", nome: "Prédio" },
            { id: "Conjunto", nome: "Conjunto" },
            { id: "Ponto", nome: "Ponto" },
            { id: "Terreno comercial", nome: "Terreno comercial" }
            ]
        }
        ],
    }),
    methods: {
        startLoading() {
            this.isLoading = true;
        },
        stopLoading() {
            this.isLoading = false;
        },
        //garantidoras
        async BuscaImobialiarias() {
            if (this.selectedGarantidora != '' && this.selectedGarantidora != null) {
                this.selectedImobiliaria = null;
                this.ListImobiliariaGeral = [];
                this.liberaEndGarantia = false;
                let _validaGar = await this.ValidaDadosGarantidora(this.selectedGarantidora.garId);
                if (_validaGar) {
                    await axios.get(`/Telas/ContratacaoGarantia/GetByGarIdParIdImobiliaria/` + this.selectedGarantidora.garId + '/0')
                        .then(response => {
                            this.ListImobiliariaGeral = response.data;
                            this.ListImobiliarias = this.ListImobiliariaGeral.filter(x => x.imoAtivo && x.imoVisivel).sort((a, b) =>
                        a.imoNomeEmpresa.localeCompare(
                        b.imoNomeEmpresa,
                        'pt',
                        { sensitivity: 'base' }
                        )
                    );
                            this.ListImobiliarias = this.ListImobiliarias.map(item => {
                                return {
                                    ...item,
                                    nomeConcatenado: `${item.imoId} - ${item.imoNomeEmpresa} - ${item.imoDocumento}`
                                };
                            });

                            if (this.User.tpeid == 3) {
                                this.ListImobiliarias = this.ListImobiliarias.filter(x => x.imoId == this.User.pesid)
                                this.selectedImobiliaria = this.ListImobiliarias[0];
                                this.SelecionarConsumidor();
                            }
                        });

                           await axios.get('/Telas/ContratacaoGarantia/GetByGarIdGarantidoraPagamento/' + this.selectedGarantidora.garId)
                            .then(response => {
                                this.DadosPagamento = response.data;
                                //console.log('this.DadosPagamento')
                                //console.log(this.DadosPagamento)

                                  axios.get(`/Telas/ContratacaoGarantia/GetAllFormasPgto`)
                                        .then(response => {
                                            if (this.DadosPagamento.length > 0 && this.DadosPagamento[0].topId != 2){
                                              this.ListaFormasPagamento = response.data.filter(x=> x.cfpVisivel);
                                            }
                                            else{
                                                this.ListaFormasPagamento = response.data.filter(x=> x.cfpVisivel && x.topId == 2);
                                            }
                                            //console.log('ListaFormasPagamento')
                                            //console.log(this.ListaFormasPagamento)
                                        });
                            })
                            .catch(error => {
                                console.error(error);
                            });

                }
            }
        },
        //consumidor
        async SelecionarConsumidor() {
            if (this.selectedImobiliaria != '' && this.selectedImobiliaria != null) {
                this.ListConsumidor = [];
                this.selectedConsumidor = null;
                this.liberaEndGarantia = false;
                let valido = await this.ValidaDadosImobiliaria(this.selectedImobiliaria.imoId);
                if (valido) {
                    axios.get(`/Telas/ContratacaoGarantia/GetByGarIdImoIdClientes/0/` + this.selectedImobiliaria.imoId)
                        .then(response => {
                            this.ListConsumidor = response.data.filter(x => x.cliAtivo).sort((a, b) =>
                        a.cliNomeEmpresa.localeCompare(
                        b.cliNomeEmpresa,
                        'pt',
                        { sensitivity: 'base' }
                        )
                    );
                            this.ListConsumidor = this.ListConsumidor.map(item => {
                                return {
                                    ...item,
                                    nomeConcatenado: `${item.cliId} - ${item.cliNomeEmpresa} - ${item.cliDocumento}`
                                };
                            });
                        });
                }
            }
            // console.log('Produto Adicional Selecionado:', this.selectedImobiliaria);
        },
        async ValidaConsumidor() {
            let valido = await this.ValidaDadosCliente(this.selectedConsumidor.cliId);
                if (valido) {
                       this.ListaConsultasCredito = [];
                       await axios.get(`/Telas/ContratacaoGarantia/GetBycliIdClientesConsultas/` + this.selectedConsumidor.cliId)
                        .then(response => {
                            if (response.data.length > 0) {
                                this.ListaConsultasCredito = response.data;
                            }
                            else {
                                this.ListaConsultasCredito = [];
                            }
                        });

                      this.liberaEndGarantia = true;
                }
                else{
                    this.liberaEndGarantia = false;
                }
                      
        },
        //consumidor
        //endereco
        Buscacep(value) {
            if (this.numCep != '') {
                fetch("https://viacep.com.br/ws/" + value + "/json/")
                    .then(response => {
                        if (!response.ok) {
                            this.$mensagemAviso("CEP inexistente");
                            throw new Error("CEP inexistente");
                        }
                        return response.json();
                    })
                    .then(data => {
                        this.Retornocep = data;
                        if (this.Retornocep != null) {
                            this.endereco = this.Retornocep.logradouro;
                            this.numeroend = null;
                            this.complemento = null;
                            this.siglaEstado = this.Retornocep.uf;
                            this.nomeCidade = this.Retornocep.localidade;
                            this.nomeBairro = this.Retornocep.bairro;
                            this.showend = true;
                        } else {
                            this.$mensagemAviso("CEP inexistente");
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
            else {
                this.$mensagemAviso("Digite um cep válido");
            }

        },
        ValidaEndereco() {
            if (this.numCep == '' || this.numCep == null) {
                this.$mensagemAviso("Preencha o CEP");
            }
            else if (this.endereco == '' || this.endereco == null) {
                this.$mensagemAviso("Preencha o Endereço");
            }
            else if (this.numeroend == '' || this.numeroend == null) {
                this.$mensagemAviso("Preencha o número do endereço");
            }
            else if (this.complemento == '' || this.complemento == null) {
                this.$mensagemAviso("Preencha complemento (casa, apto, etc)");
            }
            else if (this.siglaEstado == '' || this.siglaEstado == null) {
                this.$mensagemAviso("Preencha sigla do estado");
            }
            else if (this.nomeCidade == '' || this.nomeCidade == null) {
                this.$mensagemAviso("Preencha nome da cidade");
            }
            else if (this.nomeBairro == '' || this.nomeBairro == null) {
                this.$mensagemAviso("Preencha nome do bairro");
            }
            else if (this.tipoImovel == '' || this.tipoImovel == null) {
                this.$mensagemAviso("Selecione tipo de imóvel");
            }
            else if (this.tipoImovel == 'Residencial' && (this.residencialTipo == null || this.residencialTipo == '')) {
                this.$mensagemAviso("Preencha tipo de imóvel residencial no endereço.")
            }
            else {
                this.dialogEndereco = false;
                this.ListaPedidoItem = [];
                this.SalvarMemoria(2);
                this.ListProdutos = this.ListProdutosGeral.filter(x =>
                    x.proProdutos.proNomeProduto && this.tipoImovel &&
                    x.proProdutos.proNomeProduto.toLowerCase().includes(this.tipoImovel.toLowerCase())
                );
                this.ListaProdutosTaxasFilter = this.ListaProdutosTaxas.filter(x => x.tipo === this.tipoImovel);
                 console.log(' this.ListProdutos')
                 console.log( this.ListProdutos)
            }
        },
        //endereco
        //pedido
        LimparEndereco(){
            this.endereco = "";
            this.numeroend = "";
            this.complemento = "";
            this.siglaEstado = "";
            this.nomeCidade = "";
            this.nomeBairro = "";
            this.numCep = "";
            this.showend = false,
            this.tipoImovel = "";
            this.residencialTipo = "";           
            this.dialogEndereco = false;
            if (this.selectedConsumidor.cliId != null && this.selectedConsumidor.cliId!=''){
                this.liberaEndGarantia = true;
            }
            else{
                this.liberaEndGarantia = false;
            }
        },
        LimparMemoria(value) {
            localStorage.removeItem(this.$DadosCompraManual);
            if (value == 1) {
                this.$mensagemAviso("Memória Limpa.");
            }

            this.vshow = false;
            this.selectedImobiliaria = null;
            this.selectedConsumidor = null;
            this.ProdutoSelected = "";
            this.ListaPedidoItem = [];
            this.endereco = "";
            this.numeroend = "";
            this.complemento = "";
            this.siglaEstado = "";
            this.nomeCidade = "";
            this.nomeBairro = "";
            this.numCep = "";
            this.showend = false,
            this.tipoImovel = "";
            this.residencialTipo = "";
            this.TotalPedido = '';
            this.liberaEndGarantia = false;
            this.selectedFormaPagamento = null;
            this.selectedSetup = null;
            this.Get();
        },
        SalvarMemoria(value) {
            localStorage.removeItem(this.$DadosCompraManual);
            this.DadosCompra.imobiliaria = [];
            this.DadosCompra.consumidor = [];
            this.DadosCompra.garantidora = [];
            this.DadosCompra.produtos = [];
            this.DadosCompra.mensagem = [];
            this.DadosCompra.agenda = [];
            this.DadosCompra.foto = [];
            this.DadosCompra.avulsos = [];
            this.DadosCompra.informacao = [];
            this.DadosCompra.pagamento = [];
            this.DadosCompra.cupom = [];

            //garantidora
            this.DadosCompra.garantidora.push(this.selectedGarantidora);

            //imobiliaria
            this.DadosCompra.imobiliaria.push(this.selectedImobiliaria);

            //consumidor
            this.DadosCompra.consumidor.push(this.selectedConsumidor);

            //entrega
            let _agenda = {
                tipoImovel: this.tipoImovel,
                estado: this.siglaEstado,
                cidade: this.nomeCidade,
                bairro: this.nomeBairro,
                endereco: this.endereco,
                numero: this.numeroend,
                complemento: this.complemento,
                cep: this.numCep,
                residencialTipo: this.residencialTipo === null ? '' : this.residencialTipo,
            }

            this.DadosCompra.agenda.push(_agenda);


            //produto
            if (this.ListaPedidoItem.length > 0) {
                this.DadosCompra.produtos.push(this.ListaPedidoItem);
            }

             //pagamento
            if (this.selectedFormaPagamento != '' && this.selectedFormaPagamento != null) {
                this.DadosCompra.pagamento.push(this.selectedFormaPagamento);
                this.DadosCompra.informacao.push({SetupEntrada: this.selectedSetup})
            }
            this.DadosCompra.avulsos.push({QtdeMultiplicador: this.Qtdemultiplicador})


            localStorage.setItem(this.$DadosCompraManual, JSON.stringify(this.DadosCompra));
            if (value == 1) {
                this.$mensagemAviso("Salvo em memória.")
            }

        },
        AvisoSemAnalise() {
            this.$mensagemConfirma('Essa garantia não passará por uma avaliação criteriosa de crédito e jurídica, sendo de responsabilidade da garantidora esse risco')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
               this.GerarPedido(0);
            }
            });
        },
        async GerarPedido(analisar) {
            await this.SalvarMemoria(2);

            let dadosArmazenados = localStorage.getItem(this.$DadosCompraManual);
            if (dadosArmazenados) {
                dadosArmazenados = JSON.parse(dadosArmazenados);
                if (dadosArmazenados.imobiliaria == '' || this.selectedImobiliaria == null) {
                    this.$mensagemAviso("Selecione imobiliaria.")
                }
                else if (dadosArmazenados.consumidor == '' || this.selectedConsumidor == null) {
                    this.$mensagemAviso("Selecione cliente.")
                }
                else if (dadosArmazenados.agenda[0].tipoImovel == '' || dadosArmazenados.agenda[0].tipoImovel == null) {
                    this.$mensagemAviso("Preencha tipo de imóvel no endereço.")
                }
                else if (dadosArmazenados.agenda[0].tipoImovel == 'Residencial' && (dadosArmazenados.agenda[0].residencialTipo == null || dadosArmazenados.agenda[0].residencialTipo == '')) {
                    this.$mensagemAviso("Preencha tipo de imóvel residencial no endereço.")
                }
                else if (dadosArmazenados.agenda[0].estado == '' || dadosArmazenados.agenda[0].estado == null) {
                    this.$mensagemAviso("Preencha sigla do estado do endereço.")
                }
                else if (dadosArmazenados.agenda[0].cidade == '' || dadosArmazenados.agenda[0].cidade == null) {
                    this.$mensagemAviso("Preencha cidade do endereco.")
                }
                else if (dadosArmazenados.agenda[0].bairro == null || dadosArmazenados.agenda[0].bairro == "") {
                    this.$mensagemAviso("Preencha o bairro do endereço.")
                }
                else if (dadosArmazenados.agenda[0].endereco == '' || dadosArmazenados.agenda[0].endereco == null) {
                    this.$mensagemAviso("Preencha endereço.")
                }
                else if (dadosArmazenados.agenda[0].numero == "" || dadosArmazenados.agenda[0].numero == null) {
                    this.$mensagemAviso("Preencha o número do endereço.")
                }
                else if (dadosArmazenados.agenda[0].complemento == "" || dadosArmazenados.agenda[0].complemento == null) {
                    this.$mensagemAviso("Preencha o complemento (casa, apto, escritório...) do endereco.")
                }
                else if (dadosArmazenados.agenda[0].cep == "" || dadosArmazenados.agenda[0].cep == null) {
                    this.$mensagemAviso("Preencha o CEP do endereço.")
                }
                else if (dadosArmazenados.produtos[0].length == 0) {
                    this.$mensagemAviso("Adicione um produto na lista.")
                }
                else if (dadosArmazenados.pagamento.length == 0) {
                    this.$mensagemAviso("Selecione forma de pagamento.")
                }
                else if ((dadosArmazenados.informacao[0].SetupEntrada === null || dadosArmazenados.informacao[0].SetupEntrada === '') && (this.selectedFormaPagamento.cfpId == 3 || this.selectedFormaPagamento.cfpId == 4 || this.selectedFormaPagamento.cfpId == 6 || this.selectedFormaPagamento.cfpId == 7)) {
                    this.$mensagemAviso("Selecione forma de cobrança taxa setup.")
                }
                else {
                    if (this.selectedFormaPagamento.cfpId != 3) {
                        this.selectedSetup = null;
                    }
                    await this.CarregaPedido(analisar);
                             
                }
            }
        },
        async CarregaPedido(consulta) {
            this.startLoading();
            let dadosArmazenados = localStorage.getItem(this.$DadosCompraManual);
            if (dadosArmazenados) {
                dadosArmazenados = JSON.parse(dadosArmazenados);
                let _situacao = 'Aguardando Analise';
                let _pspId = 1;

                let valorTotalFinal = 0;
                let valorParcelas = 0;
                let qtdeParcelas = 0;
                let valorEntrada = 0;
                let setupEnt = dadosArmazenados.informacao[0].SetupEntrada == null ? 0 : dadosArmazenados.informacao[0].SetupEntrada;

                dadosArmazenados.produtos[0].forEach(itemprod => {
                const valor = parseFloat(itemprod.valorTotalProduto) || 0;
                valorTotalFinal += valor;
                });


                if (setupEnt == 1 && dadosArmazenados.pagamento[0].cfpId == 3){
                    let _valorSetup = parseFloat(dadosArmazenados.produtos[0][0].codSetup);
                      valorParcelas = Math.round(((valorTotalFinal-_valorSetup) / 12) * 100) / 100;
                      valorEntrada = valorParcelas + _valorSetup;
                      qtdeParcelas = 11;
                }
                else if (setupEnt == 0 && dadosArmazenados.pagamento[0].cfpId == 3){
                    valorParcelas = Math.round((valorTotalFinal / 12) * 100) / 100;
                    qtdeParcelas = 12;
                }
                else if (setupEnt > 1 && setupEnt < 14 && dadosArmazenados.pagamento[0].cfpId == 3){
                    let _par = setupEnt - 1;
                    valorParcelas = Math.round((valorTotalFinal / _par) * 100) / 100;
                    qtdeParcelas = _par;
                }
                else if (setupEnt == 14 && dadosArmazenados.pagamento[0].cfpId == 3){
                    let _par = setupEnt - 2;
                    let _valorSetup = parseFloat(dadosArmazenados.produtos[0][0].codSetup);
                    valorParcelas = Math.round(((valorTotalFinal-_valorSetup) / _par) * 100) / 100;
                    valorEntrada = _valorSetup;
                    qtdeParcelas = _par;
                }
                else if (dadosArmazenados.pagamento[0].cfpId == 2){
                    valorParcelas = Math.round((valorTotalFinal / 12) * 100) / 100;
                    valorEntrada = valorParcelas;
                    qtdeParcelas = 11;
                }
                else if (setupEnt > 1 && dadosArmazenados.pagamento[0].cfpId == 4){
                    valorParcelas = Math.round((valorTotalFinal / 1) * 100) / 100;
                    valorEntrada = valorParcelas;
                    qtdeParcelas = 1;
                }
                else if (setupEnt == 1 && dadosArmazenados.pagamento[0].cfpId == 6){
                    let _valorSetup = parseFloat(dadosArmazenados.produtos[0][0].codSetup);
                      valorParcelas = Math.round(((valorTotalFinal-_valorSetup) / 12) * 100) / 100;
                      valorEntrada = valorParcelas + _valorSetup;
                      qtdeParcelas = 11;
                }
                else if (setupEnt == 0 && dadosArmazenados.pagamento[0].cfpId == 6){
                    valorParcelas = Math.round((valorTotalFinal / 12) * 100) / 100;
                    valorEntrada = valorParcelas;
                    qtdeParcelas = 11;
                }
                else if (setupEnt > 1 && dadosArmazenados.pagamento[0].cfpId == 6){
                      let _valorSetup = parseFloat(dadosArmazenados.produtos[0][0].codSetup);
                      valorParcelas = Math.round(((valorTotalFinal-_valorSetup) / 12) * 100) / 100;
                      valorEntrada = _valorSetup;
                      qtdeParcelas = 12;
                }
                else if (setupEnt > 1 && dadosArmazenados.pagamento[0].cfpId == 7){
                    let _par = setupEnt - 1;
                    valorParcelas = Math.round((valorTotalFinal / _par) * 100) / 100;
                    qtdeParcelas = _par;
                }


                //dados do pedido
                let _pedido = {
                    PedId: 0,
                    GrtId: 0,
                    CdtId: 0,
                    IdiId: 0,
                    PedDataPedido: moment().format('YYYY-MM-DDTHH:mm:ss'),
                    PedOrigemPedido: this.selectedGarantidora.garNomeEmpresa,
                    CliId: dadosArmazenados.consumidor[0].cliId,
                    ImobId: dadosArmazenados.imobiliaria[0].imoId,
                    GarId: dadosArmazenados.garantidora[0].garId,
                    PedFormaPgto: dadosArmazenados.pagamento[0].cfpNome,
                    PedTipoPgto: String(dadosArmazenados.pagamento[0].cfpId),
                    PedValorParcelas: valorParcelas,
                    PedQtdeParcelas: qtdeParcelas,
                    PedObsLoja: '',
                    PedRetornoPgto: 'pending',
                    PedCodigoRetornoPgto: '',
                    PspId: _pspId,
                    PedSituacaoPedido: _situacao,
                    PedObsCliente: '',
                    PedUser: this.User.cusid,
                    PedValorEntrada: valorEntrada,
                    PedSetupEntrada: setupEnt == 1 ? true : setupEnt == 14 ? true : false,
                    PedCiclo: 1
                }
                // console.log('_pedido')
                // console.log(_pedido)

                await axios.post(`/Telas/ContratacaoGarantia/AddPedidos`, _pedido)
                    .then(response => {
                        if (response.data > 0) {
                            _pedido.PedId = response.data;
                            this.NumeroPedido = _pedido.PedId;
                            console.log('_pedido adicionado')
                            // console.log(_pedido)                
                        }
                    });

                //itens do pedido
                let _pedidoItens = [];
                if (dadosArmazenados.produtos[0].length > 0) {
                    await dadosArmazenados.produtos[0].forEach((itemprod) => {
                        _pedidoItens.push(
                            {
                                PdiId: 0,
                                GrtId: 0,
                                CdtId: 0,
                                IdiId: 0,
                                PedId: _pedido.PedId,
                                ProId: itemprod.proProdutos.proId,
                                PdiNomeProduto: itemprod.proProdutos.proNomeProduto,
                                PdiQtdeProduto: parseInt(itemprod.qtdeProduto),
                                PdiValorProduto: parseFloat(itemprod.valorProduto),
                                PdiValorTotalProduto: itemprod.valorTotalProduto,
                                PdiDataCadastro: moment().format('YYYY-MM-DDTHH:mm:ss'),
                                PdiDataVigenciaIni: moment(itemprod.vigenciaini).format('YYYY-MM-DD'),
                                PdiDataVigenciaFim: moment(itemprod.vigenciafim).format('YYYY-MM-DD'),
                                PdiCampoExtra1: itemprod.codSetup.toString(),
                                PdiCampoExtra2: itemprod.taxa.toString(),
                                Grid: itemprod.proProdutos.proProdutosGrids,
                            }
                        );
                    });
                }

                //pedido Endereço
                let _pedidoEndereco = {
                    PdcId: 0,
                    GrtId: 0,
                    CdtId: 0,
                    IdiId: 0,
                    PdcEndereco: dadosArmazenados.agenda[0].endereco,
                    PdcNumero: parseInt(dadosArmazenados.agenda[0].numero, 10),
                    PdcComplemento: dadosArmazenados.agenda[0].complemento,
                    PdcObsEndereco: '',
                    pdcCep: dadosArmazenados.agenda[0].cep,
                    PdcPais: 'Brasil',
                    PdcEstado: dadosArmazenados.agenda[0].estado,
                    PdcCidade: dadosArmazenados.agenda[0].cidade,
                    PdcBairro: dadosArmazenados.agenda[0].bairro,
                    PedId: _pedido.PedId,
                    PdcTipo: dadosArmazenados.agenda[0].tipoImovel,
                    PdcresidencialTipo: dadosArmazenados.agenda[0].residencialTipo,
                }

                await axios.post(`/Telas/ContratacaoGarantia/AddPedidoEndereco`, _pedidoEndereco)
                    .then(response => {
                        if (response.data > 0) {
                            console.log('_pedidoEndereco adicionado')
                            //console.log(_pedidoEndereco)                
                        }
                    });

                const parseBR = str => {
                    if (typeof str !== 'string') return 0;
                    const cleaned = str.replace(/\./g, '').replace(/,/g, '.').trim();
                    const num = parseFloat(cleaned);
                    return isNaN(num) ? 0 : num;
                    };

                    for (const itens of _pedidoItens) {
                        let avulsosLocal = [];
                    try {
                        // 1) Insere o item principal
                        const { data: newId } = await axios.post(
                        `/Telas/ContratacaoGarantia/AddPedidoItem`,
                        itens
                        );

                        if (newId > 0) {

                        await this.ContratoAdd(_pedido.PedId, newId);

                        // 2) Prepara os avulsos
                        avulsosLocal = (itens.Grid || []).map(prod => {
                            const valor = parseBR(prod.pisCampoExtra1);
                            return {
                            PiaId: 0,
                            GrtId: 0,
                            CdtId: 0,
                            IdiId: 0,
                            PedId: _pedido.PedId,
                            PiaNomeProduto: prod.pisNome,
                            PiaQtdeProduto: 1,
                            PiaValorProduto: valor,
                            PiaValorTotalProduto: valor,
                            PiaDataCadastro: moment().format('YYYY-MM-DDTHH:mm:ss'),
                            PiaCampoExtra1: '',
                            };
                        });

                            // 4) Insere cada avulso
                            for (const av of avulsosLocal) {
                                await axios.post(`/Telas/ContratacaoGarantia/AddPedidoItemAdicional`, av);
                            }
                        }
                    }
                    catch (err) {
                        console.error('Erro ao processar itens do pedido:', err);
                        const corpoEmail = JSON.stringify(avulsosLocal, null, 2);
                        this.EnviaEmailAviso(corpoEmail);// aqui você pode decidir abortar tudo ou
                    }
                    }

                this.ValidaAprovacao(_pedido, consulta);

            }
        },
        async ValidaAprovacao(pedidoDados, consulta) {

            let dadosArmazenados = localStorage.getItem(this.$DadosCompraManual);

            if (dadosArmazenados) {
                dadosArmazenados = JSON.parse(dadosArmazenados);
                let _analiseCredito = {
                    pedId: pedidoDados.PedId,
                    documentoList: [dadosArmazenados.consumidor[0].cliDocumento.replaceAll('.', '').replaceAll('-', '').replaceAll('/','')],
                    fonteList: ['cdl', 'jus'], //retirado 'ser' 10-03-2026
                    validarRegra: true,
                    fazerAnalise: consulta,
                    garId: dadosArmazenados.garantidora[0].garId,
                    imoId: dadosArmazenados.imobiliaria[0].imoId,
                    cliId: dadosArmazenados.consumidor[0].cliId
                }

                await axios.post(`/Telas/ContratacaoGarantia/CheckAnaliseCredito`, _analiseCredito)
                    .then(response => {
                        console.log(response.data)
                    });
            }
            this.$router.push('/listacontratacoes')
        },
        calculatotal() {
            var valorProdutos = 0;
            var vcount = 0;

            if (this.ListaPedidoItem != '') {

                this.ListaPedidoItem.forEach(item => {
                    valorProdutos += item.valorTotalProduto;
                    vcount++;
                });
            }
            this.TotalPedido = (valorProdutos);

        },
        ExcluiProduto(index) {
            this.ListaPedidoItem.splice(index, 1);
            //this.calculatotal();
        },
        buildFileUrl(path) {
            if (!path) return '';
            const rel  = String(path).replace(/\\/g, '/'); // normaliza separadores
            const base = this.$imgURL;
            return `${base}/Telas/ContratacaoGarantia/GetFileByParam?param=${encodeURIComponent(rel)}&t=${Date.now()}`;
        },
        //pedido
        async ContratoAdd(_pedId, _pdiId) {
            let dadosArmazenados = localStorage.getItem(this.$DadosCompraManual);

            if (dadosArmazenados) {
                dadosArmazenados = JSON.parse(dadosArmazenados);

                //validar se o cliente tem um contrato especifico
                let _cmcId = 4;
                if (dadosArmazenados.consumidor[0].tpdId == 2) {
                    _cmcId = 5;
                }
                
                let result = this.ListaContratos.filter(x=> x.garId == this.selectedGarantidora.garId && x.tpdId == dadosArmazenados.consumidor[0].tpdId);
                if (result.length > 0){
                   _cmcId = result[0].cmcId;
                }

                var _dadosContrato = {
                    TipoPessoa: 4,
                    CmcId: _cmcId,
                    IdContratante: dadosArmazenados.consumidor[0].cliId,
                    IdContratada: dadosArmazenados.garantidora[0].garId,
                    dadosContratacao: {
                        idPedido: _pedId,
                        multiplicador: dadosArmazenados.avulsos[0].QtdeMultiplicador,
                        valorContratado: dadosArmazenados.produtos[0][0].valorTotalProduto.toString(),
                        custoSaida: '3x',
                        valorLocaticio: '0',
                        valorTaxa: dadosArmazenados.produtos[0][0].taxa.toString(),
                        setup: dadosArmazenados.produtos[0][0].codSetup.toString(),
                        tipoCalculoTaxa: (dadosArmazenados.produtos[0][0].tipoCalculoTaxa || 'taxa').toString(),
                        valorPacoteInformado: dadosArmazenados.produtos[0][0].valorPacoteInformado != null ? dadosArmazenados.produtos[0][0].valorPacoteInformado.toString() : null
                    }
                }

                var _pedidoDocumento = {
                    pftId: 0,
                    grtId: 0,
                    cdtId: 0,
                    pftUrlImagem: null,
                    pedId: _pedId,
                    pdiId: _pdiId,
                    pftDadosContrato: JSON.stringify(_dadosContrato.dadosContratacao)
                }

                await axios.post(`/Telas/ContratacaoGarantia/AddPedidoDocumento`, _pedidoDocumento)
                    .then(response => {
                        if (response.data > 0) {
                            _pedidoDocumento.pftId = response.data;
                        }
                    });
            }
        },
        //produtos
        toggle(mes) {
            this.ProdutoSelected = mes;
            if (mes.proProdutos.proId == 1 || mes.proProdutos.proId == 2) {
                let dadosArmazenados = localStorage.getItem(this.$DadosCompraManual);
                if (dadosArmazenados) {
                    dadosArmazenados = JSON.parse(dadosArmazenados);
                    if (dadosArmazenados.produtos.length > 0) {
                        this.ProdutosGrid = dadosArmazenados.produtos[0][0].proProdutos.proProdutosGrids;
                       //console.log('aqui1')
                        this.ProdutosGrid.forEach(element => {
                            if (element.pisCampoExtra1 == '' || element.pisCampoExtra1 == null) {
                                element.pisCampoExtra1 = 0;
                            }
                        });
                    }
                    else {
                        //console.log('aqui')
                        axios.get(`/Telas/ContratacaoGarantia/GetAllByProIdItens/${mes.proProdutos.proId}`)
                            .then(response => {
                                this.ProdutosGrid = response.data;
                                this.ProdutosGrid.forEach(element => {
                                    if (element.pisCampoExtra1 == '' || element.pisCampoExtra1 == null) {
                                        element.pisCampoExtra1 = 0;
                                    }
                                });
                            });
                    }
                }
                else {
                    axios.get(`/Telas/ContratacaoGarantia/GetAllByProIdItens/${mes.proProdutos.proId}`)
                        .then(response => {
                            this.ProdutosGrid = response.data; /*.sort((a, b) => {
                                                                            const valorA = parseInt(a.pimOrdem) || 0;
                                                                            const valorB = parseInt(b.pimOrdem) || 0;
                                                                            return valorA - valorB;
                                                                        });*/
                           // console.log('aqui2')
                            this.ProdutosGrid.forEach(element => {
                                if (element.pisCampoExtra1 == '' || element.pisCampoExtra1 == null) {
                                    element.pisCampoExtra1 = 0;
                                }
                            });

                            // console.log('mes')
                            // console.log(mes)

                            //  console.log('ProdutosGrid')
                            //  console.log(this.ProdutosGrid)

                        });
                }


                /*   axios.get(`/Process/ProProdutosPrecos/GetAllByPtcId/5/${mes.proProdutos.proId}`)
                   .then(response => {
                       this.ProdutosTaxas = response.data;                                                                 
                      // console.log('ProdutosTaxas')
                      // console.log(this.ProdutosTaxas)

                   });*/

                this.openModalProduto(1);

            }
        },
        openModalProduto(value) {
            if (value == 1) {
                this.dialogProdutoGarantia = true;
            }
            else {
                this.dialogProdutoSeguro = true;
            }
        },
        async AdicionarGarantia() {

            let _result = this.ProdutosGrid.filter(x => x.pisCampoExtra1 != 0 && x.pisCampoExtra1 != null && x.pisCampoExtra1 != '')
            if (this.selectedImobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor') {
                this.AtualizaTaxaPorValorPacote();
            }
            const taxaGarantiaCalculada = this.TaxaGarantiaComputed;

            await axios.get(`/Telas/ContratacaoGarantia/GetByGarIdPlanos/` + this.selectedGarantidora.garId)
                .then(response => {
                    if (response.data.length > 0) {

                        if (_result.length == 0) {
                            this.$mensagemAviso("Pelo menos um valor precisa ser preenchido.")
                        }
                        else if (this.PlanosGarantiasSelected == '' || this.PlanosGarantiasSelected == null) {
                            this.$mensagemAviso("Selecione taxa de setup.")
                        }
                        else if (this.selectedImobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'taxa' && (this.ProdutosTaxas == '' || this.ProdutosTaxas == null)) {
                            this.$mensagemAviso("Selecione % da taxa a ser aplicada.")
                        }
                        else if (this.selectedImobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor' && this.parseValorDecimal(this.ValorPacoteInformado) <= 0) {
                            this.$mensagemAviso("Digite o valor do pacote.")
                        }
                        else if (this.selectedImobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor' && this.ValorTotalComputed <= 0) {
                            this.$mensagemAviso("Informe os valores da cobertura para calcular a taxa.")
                        }
                        else if (this.selectedImobiliaria.planoCoberturaLivre == true && taxaGarantiaCalculada == null) {
                            this.$mensagemAviso("NÃ£o foi possÃ­vel calcular a taxa.")
                        }
                        else if (response.data[0].gplValorMaxSetup > this.PlanosGarantiasSelected) {
                            this.$mensagemAviso("Valor Setup deve ser acima de " + response.data[0].gplValorMaxSetup)
                        }
                        else if (this.selectedImobiliaria.planoCoberturaLivre == true && (this.Qtdemultiplicador == '' || this.Qtdemultiplicador == null)){
                            this.$mensagemAviso("Selecione Qtde Vezes Cobertura")
                        } 
                         else if (this.selectedImobiliaria.planoCoberturaLivre == false && this.CoberturaSelected == null){
                            this.$mensagemAviso("Selecione Qtde Vezes Cobertura")
                        } 
                        else {
                            this.ListaPedidoItem = [];
                            var qtdeprod = 1;
                            const valorPacote = this.ValorPacoteGarantiaComputed;
                            const valorSetup = this.parseValorDecimal(this.PlanosGarantiasSelected);
                            this.ProdutoSelected.qtdeProduto = qtdeprod;
                            this.ProdutoSelected.valorTotalProduto = qtdeprod * (parseFloat(valorPacote) + parseFloat(valorSetup));
                            this.ProdutoSelected.valorProduto = (parseFloat(valorPacote) + parseFloat(valorSetup));
                            this.ProdutoSelected.codSetup = this.PlanosGarantiasSelected;
                            this.ProdutoSelected.taxa = taxaGarantiaCalculada;
                            this.ProdutoSelected.tipoCalculoTaxa = this.selectedImobiliaria.planoCoberturaLivre == true ? this.TipoCalculoTaxa : 'taxa';
                            this.ProdutoSelected.valorPacoteInformado = this.ProdutoSelected.tipoCalculoTaxa == 'valor' ? valorPacote : null;
                            this.ProdutoSelected.vigenciaini = moment();
                            this.ProdutoSelected.vigenciafim = moment(this.ProdutoSelected.vigenciaini).add(12, 'months');
                            this.ProdutoSelected.proProdutos.proProdutosGrids = this.ProdutosGrid;
                            this.ListaPedidoItem.push(this.ProdutoSelected);
                            this.SalvarMemoria(2);
                            this.dialogProdutoGarantia = false;
                            this.calculatotal();
                        }
                    }
                });

        },
        //produtos
        parseValorDecimal(value) {
            if (value == null || value === '') return 0;
            let v = value;
            if (typeof v === "string") {
                v = v.replace(/\./g, "");
                v = v.replace(/,/g, ".");
            }
            const num = parseFloat(v);
            return isNaN(num) ? 0 : num;
        },
        AtualizaTipoCalculoTaxa() {
            this.ProdutosTaxas = null;
            this.ValorPacoteInformado = null;
        },
        AtualizaTaxaPorValorPacote() {
            this.ProdutosTaxas = this.TaxaGarantiaComputed;
        },
        formatarPercentualTaxa(value) {
            const taxa = parseFloat(value);
            if (isNaN(taxa)) return '0%';
            return `${(taxa * 100).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 })}%`;
        },
        AtualizaTaxasPlanos() {
            if (this.CoberturaSelected != null){
                this.ProdutosTaxas = this.CoberturaSelected.ipcPercentualGarantia;
                this.Qtdemultiplicador = this.CoberturaSelected.ipcCobertura + 'x';
            }
            else{
                this.ProdutosTaxas = null;
                this.Qtdemultiplicador = null;
            }
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
            });
        },
        async ValidaDadosGarantidora(garid) {
            console.log('1: Iniciando validação de garantidora');

            try {
                // 1) Busca dados da garantidora
                const { data: garantidora } = await axios.get(`/Telas/ContratacaoGarantia/GetByIdGarantidora/${garid}`);
                console.log('2: Dados da garantidora recebidos');

                // Valida campos obrigatórios da garantidora
                if (garantidora == null || garantidora === '') {
                    this.$mensagemAviso("Garantidora não encontrada.");
                    return false;
                }
                if (garantidora.tpdId == null) {
                    this.$mensagemAviso("Garantidora Campo Tipo Pessoa Obrigatório.");
                    return false;
                }
                if (garantidora.garDocumento == null || garantidora.garDocumento === '') {
                    this.$mensagemAviso("Garantidora Campo Nº Documento Obrigatório.");
                    return false;
                }
                if (garantidora.garNomeEmpresa == null || garantidora.garNomeEmpresa === '') {
                    this.$mensagemAviso("Garantidora Campo Nome Obrigatório.");
                    return false;
                }
                if ((garantidora.garRazaoSocial == null || garantidora.garRazaoSocial === '') && garantidora.tpdId == 2) {
                    this.$mensagemAviso("Garantidora Campo Razão Social Obrigatório.");
                    return false;
                }
                if (garantidora.garTelefone == null || garantidora.garTelefone === '') {
                    this.$mensagemAviso("Garantidora Campo Telefone Obrigatório.");
                    return false;
                }
                if (garantidora.garWhatsapp == null || garantidora.garWhatsapp === '') {
                    this.$mensagemAviso("Garantidora Campo Whatsapp Obrigatório.");
                    return false;
                }
                if (garantidora.garEmail == null || garantidora.garEmail === '') {
                    this.$mensagemAviso("Garantidora Campo E-mail Obrigatório.");
                    return false;
                }
                if (garantidora.tpdId === 2 && (garantidora.garResponsavel == null || garantidora.garResponsavel === '')) {
                    this.$mensagemAviso("Garantidora Campo Responsável Obrigatório.");
                    return false;
                }
                if (garantidora.tpdId === 2 && (garantidora.garCampoExtra1 == null || garantidora.garCampoExtra1 === '')) {
                    this.$mensagemAviso("Garantidora Campo CPF Responsável Obrigatório.");
                    return false;
                }

                console.log('3: Garantidora OK, buscando endereço');

                // 2) Busca dados de endereço
                const { data: enderecos } = await axios.get(`/Telas/ContratacaoGarantia/GetByGarIdEndereco/${garid}`);
                const endereco = Array.isArray(enderecos) ? enderecos[0] : null;

                if (endereco == null) {
                    this.$mensagemAviso("Endereço Garantidora não encontrado.");
                    return false;
                }
                if (endereco.gaeCep == null || endereco.gaeCep === '') {
                    this.$mensagemAviso("Endereço Garantidora - Campo CEP Obrigatório.");
                    return false;
                }
                if (endereco.gaeEndereco == null || endereco.gaeEndereco === '') {
                    this.$mensagemAviso("Endereço Garantidora - Campo Endereço Obrigatório.");
                    return false;
                }
                // aceita 0, mas reprova '' ou null/undefined
                if (endereco.gaeNumero == null || endereco.gaeNumero === '') {
                    this.$mensagemAviso("Endereço Garantidora - Campo Número Obrigatório.");
                    return false;
                }
                if (endereco.gaeEstado == null || endereco.gaeEstado === '') {
                    this.$mensagemAviso("Endereço Garantidora - Campo Estado Obrigatório.");
                    return false;
                }
                if (endereco.gaeCidade == null || endereco.gaeCidade === '') {
                    this.$mensagemAviso("Endereço Garantidora - Campo Cidade Obrigatório.");
                    return false;
                }
                if (endereco.gaeBairro == null || endereco.gaeBairro === '') {
                    this.$mensagemAviso("Endereço Garantidora - Campo Bairro Obrigatório.");
                    return false;
                }

                console.log('4: Endereço OK, validação completa');
                return true;
            }
            catch (error) {
                console.error('Erro na ValidaDadosGarantidora:', error);
                this.$mensagemErro("Falha ao validar dados da garantidora. Tente novamente.");
                return false;
            }
        },
        async ValidaDadosImobiliaria(imoId) {
            console.log('1: Iniciando validação de imobiliária');

            try {
                // 1) Busca dados da imobiliária
                const { data: imobiliaria } = await axios.get(`/Telas/ContratacaoGarantia/GetByIdImobiliaria/${imoId}`);
                console.log('2: Dados da imobiliária recebidos');

                // Validações da Imobiliária
                if (imobiliaria.garId == null || imobiliaria.garId === '') {
                    this.$mensagemAviso("Imobiliária - Campo Garantidora Obrigatório.");
                    return false;
                }
                if (imobiliaria.tpdId == null || imobiliaria.tpdId === '') {
                    this.$mensagemAviso("Imobiliária - Campo Tipo Pessoa Obrigatório.");
                    return false;
                }
                if (imobiliaria.imoDocumento == null || imobiliaria.imoDocumento === '') {
                    this.$mensagemAviso("Imobiliária - Campo Nº Documento Obrigatório.");
                    return false;
                }
                if (imobiliaria.imoNomeEmpresa == null || imobiliaria.imoNomeEmpresa === '') {
                    this.$mensagemAviso("Imobiliária - Campo Nome Obrigatório.");
                    return false;
                }
                if (imobiliaria.tpdId === 2 && (imobiliaria.imoRazaoSocial == null || imobiliaria.imoRazaoSocial === '')) {
                    this.$mensagemAviso("Imobiliária - Campo Razão Social Obrigatório.");
                    return false;
                }
                if (imobiliaria.imoTelefone == null || imobiliaria.imoTelefone === '') {
                    this.$mensagemAviso("Imobiliária - Campo Telefone Obrigatório.");
                    return false;
                }
                if (imobiliaria.imoWhatsapp == null || imobiliaria.imoWhatsapp === '') {
                    this.$mensagemAviso("Imobiliária - Campo Whatsapp Obrigatório.");
                    return false;
                }
                if (imobiliaria.imoEmail == null || imobiliaria.imoEmail === '') {
                    this.$mensagemAviso("Imobiliária - Campo E-mail Obrigatório.");
                    return false;
                }
                if (imobiliaria.tpdId === 2 && (imobiliaria.imoResponsavel == null || imobiliaria.imoResponsavel === '')) {
                    this.$mensagemAviso("Imobiliária - Campo Responsável Obrigatório.");
                    return false;
                }
                if (imobiliaria.tpdId === 2 && (imobiliaria.imoCampoExtra1 == null || imobiliaria.imoCampoExtra1 === '')) {
                    this.$mensagemAviso("Imobiliária - Campo CPF Responsável Obrigatório.");
                    return false;
                }
                if (imobiliaria.imoCreci == null || imobiliaria.imoCreci === '') {
                    this.$mensagemAviso("Imobiliária - Campo Creci Obrigatório.");
                    return false;
                }

                console.log('3: Imobiliária OK, buscando endereço');

                // 2) Busca dados de endereço da imobiliária
                const { data: enderecos } = await axios.get(`/Telas/ContratacaoGarantia/GetByImoIdEndereco/${imoId}`);
                const endereco = Array.isArray(enderecos) ? enderecos[0] : null;

                if (endereco == null) {
                    this.$mensagemAviso("Endereço da Imobiliária não encontrado.");
                    return false;
                }
                if (endereco.imeCep == null || endereco.imeCep === '') {
                    this.$mensagemAviso("Campo CEP da Imobiliária Obrigatório.");
                    return false;
                }
                if (endereco.imeEndereco == null || endereco.imeEndereco === '') {
                    this.$mensagemAviso("Campo Endereço da Imobiliária Obrigatório.");
                    return false;
                }
                if (endereco.imeNumero == null || endereco.imeNumero === '') {
                    this.$mensagemAviso("Campo Número da Imobiliária Obrigatório.");
                    return false;
                }
                if (endereco.imeEstado == null || endereco.imeEstado === '') {
                    this.$mensagemAviso("Campo Estado da Imobiliária Obrigatório.");
                    return false;
                }
                if (endereco.imeCidade == null || endereco.imeCidade === '') {
                    this.$mensagemAviso("Campo Cidade da Imobiliária Obrigatório.");
                    return false;
                }
                if (endereco.imeBairro == null || endereco.imeBairro === '') {
                    this.$mensagemAviso("Campo Bairro da Imobiliária Obrigatório.");
                    return false;
                }

                // 3) Busca dados de Planos cobertura da imobiliária
                const { data: planos } = await axios.get(`/Telas/ContratacaoGarantia/GetPlanosCoberturaByImoId/${imoId}`);
                this.ListaPlanosCobertura = planos;
              
                if (imobiliaria.planoCoberturaLivre == false && 
                    (this.ListaPlanosCobertura.filter(x=> x.ipcTipoCobertura == 'Residencial').length == 0 
                    || this.ListaPlanosCobertura.filter(x=> x.ipcTipoCobertura == 'Comercial').length == 0)){
                     this.$mensagemAvisoConfirm("Necessário cadastro de Planos de Cobertura, entre em contato com Garantidora.");
                    return false;
                }
                console.log('4: Endereço OK, validação completa');
                return true;
            }
            catch (error) {
                console.error('Erro na ValidaDadosImobiliaria:', error);
                this.$mensagemErro("Falha ao validar dados da imobiliária. Tente novamente.");
                return false;
            }
        },
        async ValidaDadosCliente(cliId) {
            console.log('1: Iniciando validação de cliente');
            try {
                // 1) Carrega dados do cliente
                const { data: cliente } = await axios.get(`/Telas/ContratacaoGarantia/GetByIdCliente/${cliId}`);
                console.log('2: Dados do cliente recebidos', cliente);

                // 2) Validações básicas
                if (cliente.garId == null || cliente.garId === '') {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Garantidora Obrigatório.");
                    return false;
                }
                if (cliente.imoId == null || cliente.imoId === '') {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Imobiliária Obrigatório.");
                    return false;
                }
                if (cliente.tpdId == null || cliente.tpdId === '') {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Tipo Pessoa Obrigatório.");
                    return false;
                }
                if (cliente.cliDocumento == null || cliente.cliDocumento === '') {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Nº Documento Obrigatório.");
                    return false;
                }
                if (cliente.cliNomeEmpresa == null || cliente.cliNomeEmpresa === '') {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Nome Obrigatório.");
                    return false;
                }
                if (cliente.cliTelefone == null || cliente.cliTelefone === '') {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Telefone Obrigatório.");
                    return false;
                }
                if (cliente.cliWhatsapp == null || cliente.cliWhatsapp === '') {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Whatsapp Obrigatório.");
                    return false;
                }
                // PF exige data de nascimento
                if (
                    cliente.tpdId === 1 &&
                    (cliente.cliDataNascimento == null || cliente.cliDataNascimento === '')
                ) {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Data Nascimento Obrigatório.");
                    return false;
                }
                if (cliente.cliEmail == null || cliente.cliEmail === '') {
                    this.$mensagemAviso("Cadastro do Cliente - Campo E-mail Obrigatório.");
                    return false;
                }
                // PJ exige responsável e CPF
                if (
                    cliente.tpdId === 2 &&
                    (cliente.cliResponsavel == null || cliente.cliResponsavel === '')
                ) {
                    this.$mensagemAviso("Cadastro do Cliente - Campo Responsável Obrigatório.");
                    return false;
                }
                if (
                    cliente.tpdId === 2 &&
                    (cliente.cliCampoExtra1 == null || cliente.cliCampoExtra1 === '')
                ) {
                    this.$mensagemAviso("Cadastro do Cliente - Campo CPF Responsável Obrigatório.");
                    return false;
                }
                // Campos adicionais PF
                if (cliente.tpdId === 1) {
                    if (cliente.cliNomePai == null || cliente.cliNomePai === '') {
                        this.$mensagemAviso("Cadastro do Cliente - Campo Nome Pai Obrigatório.");
                        return false;
                    }
                    if (cliente.cliNomeMae == null || cliente.cliNomeMae === '') {
                        this.$mensagemAviso("Cadastro do Cliente - Campo Nome Mãe Obrigatório.");
                        return false;
                    }
                    if (cliente.cliEstadoCivil == null || cliente.cliEstadoCivil === '') {
                        this.$mensagemAviso("Cadastro do Cliente - Campo Estado Civil Obrigatório.");
                        return false;
                    }
                }
                console.log('3: Cliente OK, buscando endereço cadastrado');

                // 3) Valida endereço cadastrado
                const { data: enderecos } = await axios.get(
                    `/Telas/ContratacaoGarantia/GetEnderecoByCli/${cliId}`
                );
                const endereco = Array.isArray(enderecos) ? enderecos[0] : null;
                if (endereco == null) {
                    this.$mensagemAviso("Endereço do cadastro do cliente não foi localizado.");
                    return false;
                }
                if (endereco.cleCep == null || endereco.cleCep === '') {
                    this.$mensagemAviso("Campo CEP do cadastro do cliente Obrigatório.");
                    return false;
                }
                if (endereco.cleEndereco == null || endereco.cleEndereco === '') {
                    this.$mensagemAviso("Campo Endereço do cadastro do cliente Obrigatório.");
                    return false;
                }
                if (endereco.cleNumero == null || endereco.cleNumero === '') {
                    this.$mensagemAviso("Campo Número do cadastro do cliente Obrigatório.");
                    return false;
                }
                if (endereco.cleEstado == null || endereco.cleEstado === '') {
                    this.$mensagemAviso("Campo Estado do cadastro do cliente Obrigatório.");
                    return false;
                }
                if (endereco.cleCidade == null || endereco.cleCidade === '') {
                    this.$mensagemAviso("Campo Cidade do cadastro do cliente Obrigatório.");
                    return false;
                }
                if (endereco.cleBairro == null || endereco.cleBairro === '') {
                    this.$mensagemAviso("Campo Bairro do cadastro do cliente Obrigatório.");
                    return false;
                }

                console.log('4: Endereço OK, validação completa');
                return true;
            }
            catch (error) {
                console.error('Erro na ValidaDadosCliente:', error);
                this.$mensagemErro("Falha ao validar dados do cliente. Tente novamente.");
                return false;
            }
        },
        EnviaEmailAviso(texto){
              axios.get(`/Telas/ContratacaoGarantia/GetByIdMensagemPadrao/16`)
                      .then(response => {
                        this.templateEmail = response.data;
                            let _dadosEmail = {
                                            nomeDe: this.$GarantePayNome,
                                            nomePara: "Luciano",
                                            assunto: 'Erro Pedido Adicional - Sistema GarantePay',
                                            destinatario: "contato@avancedigital.com.br",
                                            emailResposta: "contato@avancedigital.com.br",
                                            textoEmail: this.templateEmail.mpdTexto
                                                        .replace('[Texto]',texto),
                                            listAnexos: null //{nomeAnexo: '', anexo: '', tipoAnexo: ''}
                                        }
                                axios.post(`/Telas/ContratacaoGarantia/Enviamail`,_dadosEmail);
            });
        },
        async Get() {
            await axios.get(`/Telas/ContratacaoGarantia/GetDados`)
               .then(response => {
                   this.Situacoes = response.data.cadSituacaoPedido;
                   this.ListProdutosGeral = response.data.produtosSegmentos.filter(x => x.proProdutos.proVisivel);
                    this.ListProdutosGeral = this.ListProdutosGeral.map(item => {
                        return {
                            ...item,
                            nomeConcatenado: `${item.proProdutos.proNomeProduto}`
                        };
                    });
                    // Fazer a distinção dos itens com base na propriedade nomeConcatenado
                    const distinctItems = this.ListProdutosGeral.filter((item, index, self) =>
                        index === self.findIndex(t => (
                            t.nomeConcatenado === item.nomeConcatenado
                        ))
                    );
                    this.ListProdutosGeral = distinctItems.sort((a, b) => {
                        const nomeA = a.proProdutos.proNomeProduto || "";
                        const nomeB = b.proProdutos.proNomeProduto || "";
                        return nomeA.localeCompare(nomeB);
                    });

                    this.ListaContratos = response.data.modelosContratos;
               
                this.User.tpeid = response.data.tpeId
                this.User.garid = response.data.garId
                this.User.pesid = response.data.pesId
                this.User.cusid = response.data.cusId;
                
                 this.DadosGarantidora = response.data.garantidoras.filter(x => x.garAtivo && x.garVisivel).sort((a, b) =>
                        a.garNomeEmpresa.localeCompare(
                        b.garNomeEmpresa,
                        'pt',
                        { sensitivity: 'base' }
                        )
                    );
                    if (this.User.garid != 0) {
                        this.selectedGarantidora = this.DadosGarantidora[0];
                        this.BuscaImobialiarias();
                    }
                    this.DadosConfiguracao = response.data.garantidoraSerasa;
                    this.TipoOperadoras = response.data.tipoOperadoras;
         });           

            let dadosArmazenados = localStorage.getItem(this.$DadosCompraManual);
            if (dadosArmazenados) {
                dadosArmazenados = JSON.parse(dadosArmazenados);
                if (dadosArmazenados.consumidor != '') {
                    this.selectedGarantidora = dadosArmazenados.garantidora[0];
                    await this.BuscaImobialiarias();
                    this.selectedImobiliaria = dadosArmazenados.imobiliaria[0];
                    this.SelecionarConsumidor();
                    this.selectedConsumidor = dadosArmazenados.consumidor[0];

                    if (dadosArmazenados.agenda != '') {
                        //endereco
                        this.tipoImovel = dadosArmazenados.agenda[0].tipoImovel;
                        this.nomeCidade = dadosArmazenados.agenda[0].cidade;
                        this.siglaEstado = dadosArmazenados.agenda[0].estado;
                        this.nomeBairro = dadosArmazenados.agenda[0].bairro;
                        this.endereco = dadosArmazenados.agenda[0].endereco;
                        this.numeroend = dadosArmazenados.agenda[0].numero;
                        this.complemento = dadosArmazenados.agenda[0].complemento;
                        this.numCep = dadosArmazenados.agenda[0].cep;
                        this.residencialTipo = dadosArmazenados.agenda[0].residencialTipo;
                        this.teste = dadosArmazenados.agenda[0].residencialTipo;
                        this.showend = true;
                        this.liberaEndGarantia = true;
                    }
                     console.log('this.residencialTipo')
                     console.log(this.residencialTipo)
                    //console.log('this.ListProdutosGeral')
                    // console.log(this.ListProdutosGeral)

                    this.ListProdutos = this.ListProdutosGeral.filter(x =>
                        x.proProdutos.proNomeProduto && this.tipoImovel &&
                        x.proProdutos.proNomeProduto.toLowerCase().includes(this.tipoImovel.toLowerCase())
                    );


                    //produtos
                    if (dadosArmazenados.produtos != '') {
                        this.ListaPedidoItem = dadosArmazenados.produtos[0];
                        this.PlanosGarantiasSelected = dadosArmazenados.produtos[0][0].codSetup;
                        this.ProdutosTaxas = dadosArmazenados.produtos[0][0].taxa;
                        this.TipoCalculoTaxa = dadosArmazenados.produtos[0][0].tipoCalculoTaxa || 'taxa';
                        this.ValorPacoteInformado = dadosArmazenados.produtos[0][0].valorPacoteInformado;
                    }
                    //pagamento
                    if (dadosArmazenados.pagamento != '') {
                        this.selectedFormaPagamento = dadosArmazenados.pagamento[0];
                    }
                    //% tacas
                    this.ListaProdutosTaxasFilter = this.ListaProdutosTaxas.filter(x => x.tipo === dadosArmazenados.agenda[0].tipoImovel);

                    this.calculatotal();
                }
            }
        }
    },
    created() {
        this.Get();
    },
    computed: {
        TaxaGarantiaComputed() {
            if (this.selectedImobiliaria && this.selectedImobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor') {
                const valorPacote = this.parseValorDecimal(this.ValorPacoteInformado);
                if (valorPacote > 0 && this.ValorTotalComputed > 0) {
                    return Number((valorPacote / this.ValorTotalComputed).toFixed(6));
                }
                return null;
            }

            const taxa = parseFloat(this.ProdutosTaxas);
            return isNaN(taxa) ? null : taxa;
        },
        ExibeResultadoGarantia() {
            if (this.selectedImobiliaria && this.selectedImobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor') {
                return this.ValorPacoteGarantiaComputed > 0 && this.TaxaGarantiaComputed != null;
            }

            return this.ProdutosTaxas != '' && this.ProdutosTaxas != null;
        },
        ValorPacoteGarantiaComputed() {
            if (this.selectedImobiliaria && this.selectedImobiliaria.planoCoberturaLivre == true && this.TipoCalculoTaxa == 'valor') {
                return Number(this.parseValorDecimal(this.ValorPacoteInformado).toFixed(2));
            }
            const taxa = this.TaxaGarantiaComputed;
            if (taxa == null) return 0;
            return Number((this.ValorTotalComputed * taxa).toFixed(2));
        },
        ValorTotalComputed() {
               let valorTotal = 0;
               let lista = [];
            
               if (this.selectedGarantidora.garId == 31){
                lista.push(this.ProdutosGrid[0]);
               }
               else{
                lista = this.ProdutosGrid;
               }

                lista.forEach(el => {
                let v = el.pisCampoExtra1;
                if (typeof v === "string") {
                    // 1) remove pontos de milhar (ex: "1.234,56" → "1234,56")
                    v = v.replace(/\./g, "");
                    // 2) troca vírgula decimal por ponto (ex: "1234,56" → "1234.56")
                    v = v.replace(/,/g, ".");
                }
                const num = parseFloat(v);
                if (!isNaN(num)) {
                    valorTotal += num;
                }
                });

                // multiplica por 12
                const totalAnual = valorTotal * 12;
                // garante duas casas decimais e devolve como Number
                return Number(totalAnual.toFixed(2));
        },
        subtiposDisponiveis() {
        const tipo = this.tiposImoveis.find(t => t.id === this.tipoImovel);
        return tipo ? tipo.subtipos : [];
        }
    },
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}


td {
    border: 1px solid #333333;
    padding: 3px;
}

.small-text {
    font-size: 10px;
    color: #dc2626;
    margin-top: 0px !important;
    position: absolute;
}


@media (min-width:1200px) {

    .fonttext {
        font-size: 14px;
    }

    /* Estilos para o select */

    .styled-select {
        display: block;
        width: 100%;
        font-size: 15px;
        padding: 0.375rem 1.75rem 0.375rem 0.75rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .altcel {
        min-height: 500px !important;
        height: auto !important;
    }

    .altavul {
        padding-top: 25px;
    }

    .btncel {
        color: #ffffff;
        min-width: 80px !important;
        font-size: 18px;
    }

    .controlcelEnd {
        height: 600px;
        width: calc(100% - 248px) !important;
        display: flex;
        flex-direction: column;
    }

}

@media (min-width:768px) {
    .altavul {
        padding-top: 35px;
    }

    .fonttext {
        font-size: 14px;
    }

    /* Estilos para o select */
    .styled-select {
        display: block;
        width: 100%;
        font-size: 15px;
        padding: 0.375rem 1.75rem 0.375rem 0.75rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .altcel {
        min-height: 500px !important;
        height: auto !important;
    }

    .altavul {
        padding-top: 25px;
    }

    .btncel {
        color: #ffffff;
        min-width: 80px !important;
        font-size: 18px;
    }
}


@media (max-width:767px) {

    .fonttext {
        font-size: 12px;
    }

    .altcel {
        min-height: 300px !important;
        height: auto !important;
    }

    .altavul {
        padding-top: 5px;
    }

    .text-h5 {
        font-size: 15px !important;
    }

    .btncel {
        color: #ffffff;
        min-width: 80px !important;
        padding: 0 !important;
        font-size: 12px;
    }

    /* Estilos para o select */
    .styled-select {
        display: block;
        width: 100%;
        font-size: 12px;
        padding: 0.375rem 1.75rem 0.375rem 0.75rem;
        line-height: 1.5;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .v-toolbar-title__placeholder {
        overflow: auto;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .v-toolbar-title {
        flex: auto !important;
        font-size: 1.25rem;
        min-width: 0;
        font-size: 1.25rem;
        font-weight: 400;
        letter-spacing: 0;
        line-height: 1.75rem;
        text-transform: none;
    }

}

.border-green {
    border: 4px solid green !important;
    /* Defina a cor e largura da borda */
    border-radius: 8px;
    /* Adicione um raio de borda para suavizar a aparência */
}

.check-icon {
    position: absolute;
    bottom: 5px;
    /* Ajuste conforme necessário */
    right: 5px;
    /* Ajuste conforme necessário */
    color: green;
    background-color: white;
    border-radius: 50%;
    padding: 5px;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    /* Adiciona sombra para destaque */
}
</style>
